import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { addAsyncCases } from 'shared/utils/redux';

import { HeadlinesState, STORE_NAME } from './initialState';
import { fetchHeadlinesDepartments } from './asyncActions';

export const headlinesSlice = createSlice({
  name: STORE_NAME,
  initialState: HeadlinesState.INITIAL_DOMAIN,
  reducers: {
    setHeadlinesCurrentSlide(state, action: PayloadAction<number>) {
      state.currentSlide = action.payload;
    },
    resetHeadlinesDepartments() {
      return { ...HeadlinesState.INITIAL_DOMAIN };
    },
  },
  extraReducers: (builder) => {
    addAsyncCases({
      builder,
      asyncActionCreator: fetchHeadlinesDepartments,
      reducer: (state, action) => {
        state.departments = action.payload;
      },
    });
  },
});

export const { setHeadlinesCurrentSlide, resetHeadlinesDepartments } = headlinesSlice.actions;
